import React, { useEffect } from "react";
import { WplywContext } from "../../../../../../../context/wplywContext";
import { useContext } from "react";
import { useState } from "react";
import numberFormat from "../../../../../../../components/numberFormat";
import formatPrice from "../../../../../../../components/formatPrice";

const ProgressBarTransfers = ({selectedPerson}) => {
  const {wplyw} = useContext(WplywContext)
  const [procent, setProcent] = useState(0)
  const [totals, setTotals] = useState((selectedPerson.msr_reckonings.reduce(
    (reck_sum, reck) => 
        reck_sum 
            + 
        (parseFloat(reck.msr_reckonings_part_amount) - parseFloat(reck.msr_reckonings_deduction_from_income))
            - reck.msr_deductions.reduce((sum2, reckded) => sum2 + parseFloat(reckded.msr_deductions_amount), 0)
    , 0) - (selectedPerson.msr_reserves_amount || 0)))
  const [leftovers, setLeftovers] = useState(0)

  useEffect(()=> {
    setTotals(selectedPerson.msr_reckonings.reduce(
      (reck_sum, reck) => 
          reck_sum 
              + 
          (parseFloat(reck.msr_reckonings_part_amount) - parseFloat(reck.msr_reckonings_deduction_from_income))
              - reck.msr_deductions.reduce((sum2, reckded) => sum2 + parseFloat(reckded.msr_deductions_amount), 0)
      , 0) - (selectedPerson.msr_reserves_amount || 0))
  }, [selectedPerson])
  useEffect(()=> {
    setLeftovers((totals).toFixed(2) - (selectedPerson.msr_transfers.reduce((sum, tr) => sum + parseFloat(tr.msr_transfers_amount),0)).toFixed(2))
  }, [selectedPerson,totals])
  useEffect(()=> {
    setProcent((totals - leftovers) / totals * 100)
  }, [selectedPerson,totals, leftovers])

  return (
    <div style={{marginTop: '10px'}}>
      <div style={{display: 'flex', width: '100%', justifyContent: 'space-between', padding: '10px', background: '#a5a5a5', borderRadius: '10px', position: 'relative', overflow: 'hidden', alignItems: 'center', gap: '15px'}}>
        <div style={{width: procent+"%", position: 'absolute', height: '100%', background: leftovers == 0 ? '#52C41A':'#DC0202', left: '0', top: '0'}}></div>
          <div style={{position: 'relative', zIndex: '4', width: '100%'}}>
            <div style={{color: "white", textAlign: 'right'}}>Kwota osoby do wypłaty</div>
            <div style={{fontWeight: 700, fontSize: "18px", color: "white", textAlign: 'right'}}>{formatPrice(totals)} zł</div>
          </div>
          <div style={{height: '30px', width: '2px', background: 'white', zIndex: '4'}}></div>
          <div style={{position: 'relative', zIndex: '4', width: '100%'}}>
            <div style={{color: "white", textAlign: 'left'}}>Pozostała kwota</div>
            <div style={{fontWeight: 700, fontSize: "18px", color: "white", textAlign: 'left'}}>
              {leftovers >= 0 ? formatPrice(leftovers)+" zł" : `Przekroczenie kwoty o ${formatPrice(leftovers * -1)+" zł"}`}
            </div>
          </div>
      </div>
    </div>
  );
};

export default ProgressBarTransfers;
